import TYPE_CODES from '@/src/cms/components/CMSPage/Publication/typeCodes';
import { convertMomentToDate } from '@/utils/dateTimeHelpers';

import style from '../assets/publicationStyle';
import sanitize from '../utils/sanitize';
import genContactCardTemplate from './contactCard';
import { generateFooterTemplate, generateHeaderTemplate } from './headerFooter';

const processBody = details => {
  return details
    .replace(/<br><br>/g, "<div class='lineBreak'></div>")
    .replace(/<i>\s<\/i>/g, '')
    .replace(/>\s</g, '><')
    .replace(/<p [^>]*>(?:(?:<br>)|\s)<\/p>/g, '')
    .replace(/^\[|\]$/gm, '');
};

const HTML_TEMPLATES = {
  bendData: ({
    data: {
      ExecutiveSummary,
      Body,
      Attachments,
      Headline,
      PublishDateTime,
      PublicationMasterCode,
      DateEffectiveNlb,
      DateOfHearingPrb,
      DateCommentsByPrb,
      BillNumber,
    },
    contacts,
    contactPics,
    hide,
    list,
    billNumTitle,
  }) => {
    const theBody = String(Body);
    const fs16 = theBody && theBody.includes('fs-16');
    return `
      <div>
        <header class="apcia-daneel-header">
          <div class="apcia-xcdwfm-container-lg-Container">
            <h1 class="apcia-pqxe18-1-normal-jumbo-Heading-title-title-Hero">
              ${Headline}
            </h1>
            <div class="apcia-kna8zu-body">
              <div class="apcia-1ms2ux0-buttons">
                <span class="apcia-1cu60kd-date">
                  <b>${convertMomentToDate(PublishDateTime)}</b>
                </span>
                ${
                  TYPE_CODES.OTHER.includes(PublicationMasterCode)
                    ? `
                    <div class="apcia-eq4skr-linksListContainer">
                      <h5 class="apcia-7g2byw-5-bolder-gray-Heading">Jurisdiction(s)</h5>
                      <ul class="apcia-okl36m-linksList">
                        ${list.Jurisdictions.map(
                          jurisdiction => `
                          <li class="apcia-zddlj8-linkItem">${jurisdiction.StateDescription}</li>
                        `
                        ).join('')}
                      </ul>
                    </div>
                    ${
                      !hide.LinesOfBusiness
                        ? `
                        <div class="apcia-eq4skr-linksListContainer">
                          <h5 class="apcia-7g2byw-5-bolder-gray-Heading">Line(s) Affected</h5>
                          <ul class="apcia-okl36m-linksList">
                            ${list.LinesOfBusiness.map(
                              lob => `
                              <li class="apcia-zddlj8-linkItem">${lob.LobDescription}</li>
                            `
                            ).join('')}
                          </ul>
                        </div>
                      `
                        : ''
                    }
                    ${
                      !hide.DateEffectiveNlb
                        ? `
                        <div class="apcia-eq4skr-linksListContainer">
                          <h5 class="apcia-7g2byw-5-bolder-gray-Heading">Effective Date</h5>
                          <ul class="apcia-okl36m-linksList">
                            <li class="apcia-zddlj8-linkItem">${convertMomentToDate(
                              DateEffectiveNlb
                            )}</li>
                          </ul>
                        </div>
                      `
                        : ''
                    }
                    ${
                      !hide.DateOfHearingPrb
                        ? `
                        <div class="apcia-eq4skr-linksListContainer">
                          <h5 class="apcia-7g2byw-5-bolder-gray-Heading">Hearing Date</h5>
                          <ul class="apcia-okl36m-linksList">
                            <li class="apcia-zddlj8-linkItem">${convertMomentToDate(
                              DateOfHearingPrb
                            )}</li>
                          </ul>
                        </div>
                      `
                        : ''
                    }
                    ${
                      !hide.DateCommentsByPrb
                        ? `
                        <div class="apcia-eq4skr-linksListContainer">
                          <h5 class="apcia-7g2byw-5-bolder-gray-Heading">Comments By</h5>
                          <ul class="apcia-okl36m-linksList">
                            <li class="apcia-zddlj8-linkItem">${convertMomentToDate(
                              DateCommentsByPrb
                            )}</li>
                          </ul>
                        </div>
                      `
                        : ''
                    }
                    ${
                      !hide.BillNumber
                        ? `
                        <div class="apcia-eq4skr-linksListContainer">
                          <h5 class="apcia-7g2byw-5-bolder-gray-Heading">${billNumTitle}</h5>
                          <ul class="apcia-okl36m-linksList">
                            <li class="apcia-zddlj8-linkItem">${BillNumber}</li>
                          </ul>
                        </div>
                      `
                        : ''
                    }
                  `
                    : ''
                }
              </div>
            </div>
          </div>
        </header>
        <section class="apcia-i2p7ik-white-Section">
          <div class="apcia-xcdwfm-container-lg-Container">
            <h2 class="apcia-ga482h-2-bolder-primaryGray-Heading-heading">Overview</h2>
            <div class="apcia-180bm0x-link-content">
              <div class="sanitized ">

              ${
                fs16
                  ? `<div class="fs-16">${sanitize(ExecutiveSummary)}</div>`
                  : sanitize(ExecutiveSummary)
              }
              </div>
            </div>
          </div>
        </section>
        ${
          Body
            ? `
          <section class="apcia-i2p7ik-white-Section">
            <div class="apcia-xcdwfm-container-lg-Container">
              <h2 class="apcia-ga482h-2-bolder-primaryGray-Heading-heading">Details</h2>
              <div class="apcia-jafrkm-link-content-2-bold-2-bold-link-PublicationBody">
                <div class="sanitized ">
                  ${sanitize(processBody(Body))}
                </div>
              </div>
            </div>
          </section>
        `
            : ''
        }
        ${
          Array.isArray(Attachments) && Attachments.length > 0
            ? `
          <section class="apcia-irk0vk-gray-Section">
            <div class="apcia-xcdwfm-container-lg-Container">
              <div id="related-info">
                <h3 id="related-info" class="apcia-1yjtbub-3-bolder-primaryGray-Heading-css-Subsection-PublicationBody">
                  Related Information
                </h3>
                <div class="apcia-3j1ie7-Subsection">
                  <div class="ant-table-wrapper apcia-1cvdee7-table-attachmentContainer">
                    <div class="ant-spin-nested-loading">
                      <div class="ant-spin-container">
                        <div
                          class="ant-table ant-table-default ant-table-without-column-header ant-table-scroll-position-left">
                          <div class="ant-table-content">
                            <div class="ant-table-body">
                              <table class="">
                                <colgroup>
                                  <col>
                                </colgroup>
                                <tbody class="ant-table-tbody">
                                  ${Attachments.map(
                                    attach => `
                                    <tr class="ant-table-row ant-table-row-level-0" data-row-key="${
                                      attach.AttachmentId
                                    }">
                                      <td class="">
                                        <a
                                          href="${process.env.API_ROOT}/attachment/page/${
                                      attach.AttachmentId
                                    }"
                                          title="${attach.FileName}"
                                          download="${attach.FileName}"
                                          class="apcia-1d6vemk-link"
                                        >
                                          <i aria-label="icon: file-image"
                                            class="anticon anticon-file-image apcia-1gtgrwu-icon">
                                            <svg viewBox="64 64 896 896"
                                              focusable="false" class="" data-icon="file-image" width="1em" height="1em"
                                              fill="currentColor" aria-hidden="true">
                                              <path
                                                d="M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8 8 0 0 1 12.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z">
                                              </path>
                                            </svg>
                                          </i>
                                          <span>${attach.FileName}</span>
                                        </a>
                                      </td>
                                    </tr>
                                  `
                                  ).join('')}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        `
            : ''
        }
        ${
          TYPE_CODES.OTHER.includes(PublicationMasterCode)
            ? `
          <section class="apcia-135xo1s-section">
            ${
              contacts.length > 0
                ? `
              <div class="apcia-ce1fcy-staffContacts">
                <div class="apcia-4vk7mv-container">
                  <div class="ant-card apcia-vkrnqj-cardSmall">
                    <div class="ant-card-head">
                      <div class="ant-card-head-wrapper">
                        <div class="ant-card-head-title">
                          <h3 class="apcia-1joqbhy-title">Contact${
                            contacts.length > 1 ? 's' : ''
                          }</h3>
                        </div>
                      </div>
                    </div>
                    <div class="ant-card-body">
                      <div class="apcia-1inls1k-inner-ContactCard">
                        ${genContactCardTemplate(contacts, contactPics)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            `
                : ''
            }
          </section>
        `
            : ''
        }
      </div>
    `;
  },
};

export function generateHTMLString(payload) {
  return `
    ${generateHeaderTemplate(style)}
    ${HTML_TEMPLATES.bendData(payload)}
    ${generateFooterTemplate()}
  `;
}
